import { gql, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { FiDownload } from "react-icons/fi";
import { useParams } from "react-router-dom";
import { download } from "utils/http";
const FETCH_PACKING_LIST_PREVIEW = gql`
  query FETCH_PACKING_LIST_PREVIEW($shipmentId: ID!) {
    packingListPreview(shipmentId: $shipmentId)
  }
`;

function PackingListPreview() {
  const { id: shipmentId } = useParams();
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const { loading, error, data } = useQuery(FETCH_PACKING_LIST_PREVIEW, {
    variables: { shipmentId },
  });

  const exportFile = (fileFormat) => {
    const setDownloading =
      fileFormat === "pdf" ? setDownloadingPdf : setDownloadingExcel;
    setDownloading(true);
    download(
      `/shipment/${shipmentId}/packing-list/${fileFormat}/`,
      "PackingList",
      null,
      { method: "post", useResponseFilename: true },
    )
      .catch((error) => Alert("error", String(error)))
      .finally(() => setDownloading(false));
  };

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;
  const html = data.packingListPreview;
  return (
    <Page
      title="Preview Packing List"
      backTo={`/shipment/shipments/${shipmentId}`}
      rightButtons={
        <div className="flex gap-6">
          <Button
            icon={<FiDownload />}
            loading={downloadingPdf}
            onClick={() => exportFile("pdf")}
          >
            Generate PDF
          </Button>
          <Button
            icon={<FiDownload />}
            loading={downloadingExcel}
            onClick={() => exportFile("xlsx")}
          >
            Generate Excel
          </Button>
        </div>
      }
    >
      <div className="flex flex-col flex-1">
        <iframe
          title="PackingLists Preview"
          className="flex-1 w-full bg-white overflow-auto"
          srcDoc={html}
        />
      </div>
    </Page>
  );
}

export default PackingListPreview;
